import fs from 'fs';
import path from 'path';
import matter from 'gray-matter';
import { NextPageWithLayout } from './_app';
import Layout from 'components/Layout';
import TextPage from 'components/TextPage';
import { serverSideTranslations } from 'next-i18next/pages/serverSideTranslations';
import { GetServerSideProps } from 'next';

interface IAboutUsProps {
  content: string | null;
  frontmatter: { title: string };
}

const AboutUs: NextPageWithLayout<IAboutUsProps> = ({
  frontmatter: { title },
  content,
}) => {
  return <TextPage title={title} content={content} />;
};

AboutUs.getLayout = (page: React.ReactElement) => (
  <Layout
    navBarClassName="bg-white py-6"
    titleProduction="meta_title_about_us"
    titleStaging="About us"
    metaDescriptionProd="meta_description_production_about_us"
    metaDescriptionStaging="Allmyles API showcase site provides a sandbox environment to test api features"
    canonicalProd="https://tipptour.com/about-us"
    canonicalStaging="https://showcase.allmyles.com/about-us">
    {page}
  </Layout>
);
export default AboutUs;

export const getServerSideProps: GetServerSideProps = async ({ locale }) => {
  const env = process.env.NEXTJS_NODE_ENV === 'production' ? 'prod' : 'dev';
  try {
    const markdownWithMeta = fs.readFileSync(
      path.join(
        process.cwd(),
        `assets/localization/about-us/${env}/${locale}.md`,
      ),
    );
    const { data: frontmatter, content } = matter(markdownWithMeta);
    return {
      props: {
        ...(await serverSideTranslations(locale || 'en')),
        frontmatter: JSON.parse(JSON.stringify(frontmatter)),
        content: content,
      } as IAboutUsProps,
    };
  } catch (err) {
    return {
      props: {
        ...(await serverSideTranslations(locale || 'en')),
        frontmatter: { title: '' },
        content: null,
      } as IAboutUsProps,
    };
  }
};
